module.exports = __webpack_public_path__ + "img/2-sdg-full@2x.abdaf123.png";